import React from "react"
import styled from "styled-components";
import { StaticImage } from "gatsby-plugin-image";
import { Section, Container, SectionTitle, SectionDescription} from "../../components/Section"


const Sections = styled(Section)`
    background: linear-gradient(to bottom,  #373636 0%,#0a0e0a 73%,#0a0e0a 73%,#ffffff 73%,#ffffff 100%);

`
const GridBox = styled.div`   
    max-width:1600px;
    width:100%;    
    padding:0 15px;
    margin:0 auto;
`
const GridInnerBox = styled.div`
    position:relative;
    &:before{
        content:'';
        background-color:#fff;
        border:1px solid #ddd;
        border-radius:20px;        
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        max-width:1410px;
    }
`
const Grid = styled.div`
    display:flex;
    flex-wrap:wrap;   
`
const LeftGrid = styled.div`
    position: relative;
    width: 100%;  
    @media(min-width:992px){
        flex: 0 0 50%;
        max-width: 50%;        
    }
`
const RightGrid = styled.div`
    position: relative;
    width: 100%;
    text-align:center;        
    @media(min-width:992px){
        flex: 0 0 50%;
        max-width: 50%;
    }
`
const Figure = styled.div`
    border-radius:10px;
    overflow:hidden;
    position:sticky;
    top:130px;
    margin:40px 0 15px 30px;
    display:none;
    @media(min-width:992px){
        margin:45px 0 30px 30px;
        display:flex;
    }
    .gatsby-image-wrapper{
        display:inline-block;
    }
`
const ListInfo = styled.ul`
    list-style:none;
    padding:0;
    counter-reset: section;
    margin:30px 15px;
    @media(min-width:992px){
        margin:30px;
    }
    strong{
        display: block;
        color:#000;
        font-weight:600;
        font-size: 18px;
        line-height: 30px;
        @media (min-width: 992px) {
            font-size: 22px;
            line-height: 32px;
        }
    }
    p{
        margin-bottom:0;        
        font-size: 14px;
        line-height: 24px;
        @media (min-width: 1200px) {
            font-size: 16px;
            line-height: 26px;
        }
        @media (min-width: 1200px) {
            font-size: 18px;
            line-height: 30px;
        }
    }
`
const ListItemInfo = styled.li`
    margin:0;
    padding:0 0 0 40px;
    position:relative;
    &::before {
        position:absolute;
        left:0;
        counter-increment: section;
        content: counter(section);    
        width: 24px;
        min-width: 24px;
        height: 24px;
        background-color: rgb(236, 44, 49);
        border-radius: 5px;
        color: rgb(255, 255, 255);
        display: inline-flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        margin-top:4px;
    }
    &:after{
        content:'';
        position:absolute;
        bottom:-15px;
        left:40px;  
        right:0;
        border-bottom:1px solid #D9D9D9;

    }
    &:last-child{
        &:after{
            display:none;
        }
    }
    + li{
        padding-top:15px;
        margin-top:15px;
    }
`
const BuildingSection = () => {
	return(
        <Sections ept="60px" epb="60px" xpt="40px" xpb="40px" pt="30px" pb="30px" className="section-building">
            <Container className="container">
                <SectionTitle textAlign="center" color="#fff">Customizing Your Metal Building</SectionTitle>
                <SectionDescription textAlign="center" color="#fff"><p>We help you design a structure that suits your needs, reflects your style, and fits your way of life. From small backyard sheds to going all out on huge agricultural buildings, you’ll be able to control every aspect of your structure, including the following:</p></SectionDescription>
            </Container>
            <GridBox>
                <GridInnerBox>
                    <Grid>
                        <LeftGrid> 
                            <ListInfo>
                                <ListItemInfo>
                                    <strong>Building Size</strong>
                                    <p>Choose your ideal length, width, and height to fit your space and storage needs.</p>
                                </ListItemInfo>
                                <ListItemInfo>
                                    <strong>Roof Style</strong>
                                    <p>Select from popular options like regular, A-frame, or vertical roofs based on your location and aesthetic.</p>
                                </ListItemInfo>
                                <ListItemInfo>
                                    <strong>Doors & Windows</strong>
                                    <p>Add roll-up garage doors, walk-in doors, or windows exactly where you want them.</p>
                                </ListItemInfo>
                                <ListItemInfo>
                                    <strong>Colors</strong>
                                    <p>Pick your favourite colour combination for the roof, trim, wainscoting, and siding.</p>
                                </ListItemInfo>
                                <ListItemInfo>
                                    <strong>Insulation</strong>
                                    <p>Add an insulation option such as double bubble, 2-inch fiberglass, or Prodex R17 to improve energy efficiency and airflow.</p>
                                </ListItemInfo>
                            </ListInfo>
                        </LeftGrid>
                        <RightGrid>
                            <Figure>
                                <StaticImage src="../../images/building-info.png" alt="Customizing Your Metal Building" />
                            </Figure>
                        </RightGrid>
                    </Grid>
                </GridInnerBox>
            </GridBox>
        </Sections>
	)
}
export default BuildingSection
